"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCirrusSignUpUrl = void 0;
const useCopWebUrl_1 = require("./useCopWebUrl");
function useCirrusSignUpUrl() {
    const copUrl = useCopWebUrl_1.useCopWebUrl();
    return `${copUrl}/portal/public/registerUser.html`;
}
exports.useCirrusSignUpUrl = useCirrusSignUpUrl;
//# sourceMappingURL=useCirrusSignUpUrl.js.map